import fnsParse from 'date-fns/parse';
import fnsFormat from 'date-fns/format';

export const parse = (date: string, format: string = 'yyyy-MM-dd HH:mm:ss', otherwise: Date = new Date()): Date => fnsParse(date, format, otherwise);
export const format = (date: Date, pattern: string = 'dd/MM/yyyy HH:mm:ss'): string => fnsFormat(date, pattern);
export const parseFormatDate = (date: string): string => {
  if (!date) return '';

  if (!date.endsWith('Z')) {
    date = `${date}Z`;
  }
  date = date.replace(' ', 'T');

  return new Date(date).toLocaleDateString('pt-br');
};
